/* eslint-disable react/require-default-props */
import React from 'react';

interface ISmlsCoinProps {
  color: string;
  className?: string;
  viewBox?: string;
}

const SmlsCoin = ({ color, className = '', viewBox = '0 0 10 16', ...rest }: ISmlsCoinProps) => (
  <svg
    {...rest}
    className={`smls-coin ${className}`.trim()}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.24 6.56C10.32 6.16 10.4 5.68 10.4 5.2C10.4 2.32 8.08 0 5.2 0C2.32 0 0 2.32 0 5.2C0 5.68 0.08 6.16 0.16 6.56C0.08 7.04 0 7.52 0 8C0 8.48 0.08 8.96 0.16 9.36C0.08 9.84 0 10.32 0 10.8C0 13.68 2.32 16 5.2 16C8.08 16 10.4 13.68 10.4 10.8C10.4 10.32 10.32 9.84 10.24 9.36C10.4 8.88 10.4 8.48 10.4 8C10.4 7.52 10.32 7.04 10.24 6.56ZM5.2 1.44C7.28 1.44 8.96 3.12 8.96 5.2C8.96 7.28 7.28 8.96 5.2 8.96C3.12 8.96 1.44 7.28 1.44 5.2C1.44 3.12 3.12 1.44 5.2 1.44ZM8.8 8.88C8.4 10.48 6.96 11.76 5.2 11.76C3.44 11.76 2 10.56 1.6 8.88C2.48 9.84 3.76 10.4 5.2 10.4C6.64 10.4 7.92 9.84 8.8 8.88ZM5.2 14.56C3.44 14.56 2 13.36 1.6 11.68C2.56 12.56 3.84 13.2 5.2 13.2C6.64 13.2 7.92 12.64 8.8 11.68C8.4 13.36 6.96 14.56 5.2 14.56Z"
      fill={color}
    />
  </svg>
);

export default SmlsCoin;
